import { format } from "date-fns";
import { api } from "./api";
import { AxiosError } from "axios";

// Type d'un employé dans la réponse
export interface OvertimeEmployee {
    employee: { id: string; name: string };
    plannedMinutes: number;
    workedMinutes: number;
    overtimeMinutes: number;
    plannedFormatted: string;   // "35h00"
    workedFormatted: string;    // "38h30"
    overtimeFormatted: string;  // "+3h30" ou "-1h00"
    status: "over" | "under" | "exact";
}

export interface OvertimeData {
    employees: OvertimeEmployee[];
    totalOvertimeMinutes: number;
    totalOvertimeFormatted: string;
    period: string;
    start: string;
    end: string;
}

interface OvertimeResponse {
    message: string;
    data: OvertimeData;
}

export const getOverTime = async (period: string, refDate: Date, companyId?: string): Promise<OvertimeData> => {
    try {
        const refDateParam = format(refDate, "yyyy-MM-dd"); // heure locale, pas UTC
        const response = await api.get<OvertimeResponse>("/overtime/stats", {
            params: { period, refDate: refDateParam, ...(companyId ? { companyId } : {}) },
        })
        return response.data.data;
    } catch (error: unknown) {
        if (error instanceof AxiosError) {
            throw new Error(
                error.response?.data?.message ||
                "Erreur lors de la récupération des dépassements"
            );
        }
        throw new Error("Erreur lors de la récupération des dépassements");
    }
}